import { render } from "./loading.vue?vue&type=template&id=2c01e644&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=2c01e644&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c01e644"]])

export default __exports__